import React, { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { Button } from './ui/Button';
export function Header() {
  const {
    lang,
    setLang,
    t
  } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToForm = () => {
    document.getElementById('consultation')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-luxury-cream/90 backdrop-blur-xl border-b border-luxury-taupe/20 py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-21">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-22">
        {/* Left: Brand */}
        <div className="flex flex-col" data-id="element-23">
          <span className={`font-heading text-xl md:text-2xl font-medium tracking-wide transition-colors duration-500 ${scrolled ? 'text-luxury-charcoal' : 'text-luxury-white'}`} data-id="element-24">
            Emelyn De Martino
          </span>
          <span className={`text-[10px] md:text-xs uppercase tracking-widest mt-0.5 transition-colors duration-500 ${scrolled ? 'text-luxury-stone' : 'text-luxury-white/70'}`} data-id="element-25">
            {t('role')}
          </span>
        </div>

        {/* Center: Collab (Hidden on mobile) */}
        <div className="hidden lg:block absolute left-1/2 -translate-x-1/2" data-id="element-26">
          <span className={`text-xs tracking-widest uppercase transition-colors duration-500 ${scrolled ? 'text-luxury-stone' : 'text-luxury-white/70'}`} data-id="element-27">
            {t('collab')}
          </span>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-4 md:gap-6" data-id="element-28">
          {/* Language Toggle */}
          <div className="flex items-center bg-luxury-warmgray/50 rounded-full p-1 border border-luxury-taupe/20" data-id="element-29">
            <button onClick={() => setLang('en')} className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all duration-300 ${lang === 'en' ? 'bg-luxury-cream text-luxury-gold shadow-sm ring-1 ring-luxury-gold/30' : 'text-luxury-stone hover:text-luxury-charcoal'}`} data-id="element-30">
              EN
            </button>
            <button onClick={() => setLang('es')} className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all duration-300 ${lang === 'es' ? 'bg-luxury-cream text-luxury-gold shadow-sm ring-1 ring-luxury-gold/30' : 'text-luxury-stone hover:text-luxury-charcoal'}`} data-id="element-31">
              ES
            </button>
          </div>

          {/* CTA */}
          <Button variant="primary" className="hidden md:inline-flex py-2.5 px-5 text-xs" onClick={scrollToForm} data-id="element-32">
            {t('reqConsultNav')}
          </Button>
        </div>
      </div>
    </header>;
}